import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";

import {
  Amount,
  Content,
  EmptyBasketContainer,
  SeeOffersWrapper,
  StartShoppingButton,
  StyledPageTitle,
  TotalToday,
} from "./styles";

import { AppDispatch } from "state/reducers-combiner";
import { configState, monetaryConfig, sendULFEvent, setModal } from "state/config-slice";
import { ULFEvents } from "types/ULF";
import generateCurrencyValue from "utils/generateCurrencyValue";
import FeatureWrapper from "components/FeatureToggle/FeatureWrapper";

const EmptyBasket: FunctionComponent = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [cookies] = useCookies();
  const { modal } = useSelector(configState);
  const monetarySettings = useSelector(monetaryConfig);

  return (
    <EmptyBasketContainer>
      <Content>
        <StyledPageTitle data-testid="empty-basket-title">{t("Your basket is empty.")}</StyledPageTitle>
        <FeatureWrapper name="Show total price">
          <TotalToday data-testid="basketTotalToday">
            {t("Total ")}
            <Amount>{generateCurrencyValue("0.00", monetarySettings)}</Amount>
            {t(" Today")}
          </TotalToday>
        </FeatureWrapper>
      </Content>
      <SeeOffersWrapper>
        <StartShoppingButton
          id="empty-basket-see-offers"
          onClick={() => {
            navigate("/");

            if (modal.showModal) {
              dispatch(setModal({ showModal: false }));
            }

            dispatch(
              sendULFEvent({
                "event-name": ULFEvents.REDIRECT_TO_HOME_PAGE,
                page: window.location.pathname,
                source: cookies.SOURCE,
                isTrackingAllowed: cookies.SUBSCRIPTIONPLUS_TRACKING || false,
              }),
            );
          }}
          title={t("See Offers")}
        />
      </SeeOffersWrapper>
    </EmptyBasketContainer>
  );
};

export default EmptyBasket;
